import { CampaignRequestProgramStageEnum } from '@/libs/openapi';
import { defineFilterListAdapter } from '@/utils/define-filter-list-adapter.util';
import { formatDate, formatEnumValue } from '@/utils/format.util';

interface ProgramFilters {
  id: number;
  stage: CampaignRequestProgramStageEnum;
  startDateGte: string;
  endDateLte: string;
}

export const programFilterListAdapter = defineFilterListAdapter<ProgramFilters>({
  id: (value) => ({
    category: 'ID',
    value: value.toString(),
  }),

  stage: (value) => ({
    category: 'Stage',
    value: formatEnumValue(CampaignRequestProgramStageEnum)(value),
  }),

  startDateGte: (value) => ({
    category: 'Start date',
    value: formatDate('full')(value),
  }),

  endDateLte: (value) => ({
    category: 'End date',
    value: formatDate('full')(value),
  }),
});
